import type { Address } from 'viem';
import factoryChains from './factory-chains.manifest.json';

export type FactoryChainRow = {
  chainId: number;
  network: string;
  envKey: string;
};

const rows = factoryChains as FactoryChainRow[];

/** Trim and strip optional quotes from .env values. */
function addr(v: string | undefined): Address | undefined {
  if (!v) return undefined;
  const t = v.trim().replace(/^['"]|['"]$/g, '');
  if (!t.startsWith('0x') || t.length !== 42) return undefined;
  return t as Address;
}

/** Set per-chain factory addresses after deployment. Keys match `factory-chains.manifest.json`. */
export const factoryByChainId: Record<number, Address | undefined> = rows.reduce(
  (acc, { chainId, envKey }) => {
    acc[chainId] = addr(process.env[envKey]);
    return acc;
  },
  {} as Record<number, Address | undefined>
);

export function getFactoryAddress(chainId: number | undefined): Address | undefined {
  if (chainId === undefined) return undefined;
  return factoryByChainId[chainId];
}
